import { useState, useEffect } from "react";
import { getSelectedColoc, Coloc } from "../services/coloc.service";

export const useSelectedColoc = () => {
  const [selectedColoc, setSelectedColoc] = useState<Coloc | null>(getSelectedColoc());

  useEffect(() => {
    const handleColocChanged = (event: Event) => {
      const customEvent = event as CustomEvent<Coloc>;
      setSelectedColoc(customEvent.detail);
    };

    window.addEventListener("colocChanged", handleColocChanged);
    return () => {
      window.removeEventListener("colocChanged", handleColocChanged);
    };
  }, []);

  return selectedColoc;
};
